module.exports = __webpack_public_path__ + "img/grafana.89866d22.svg";